import { Locale } from 'modules/i18n';

export const settingsNavTabsTranslation = {
  [Locale.en]: {
    platform: 'Platform',
    swagger: 'Platform Swagger',
    general: 'General',
    teammates: 'Teammates',
    notifications: 'Notifications',
  },
};
